export default __webpack_public_path__ + "static/media/WEX-USDC.6a532d42.png";